import React, { useEffect, useRef, useState } from "react";
import "../css/login.css";
import LoginWrapper from "./LoginWrapper";
import useAuth from "./useAuth";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useNavigate } from "react-router-dom";

const LoginFormTest = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  

  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd]);

  const validateEmptiness = () => {
    setUsernameError(user === "" ? true : false);
    setPasswordError(pwd === "" ? true : false);
  };

  const handleLoginError = (message) => {
    if (message === "Incorrect username or password.") {
      setErrMsg("Usuario o contraseña incorrectos");
    } else if (
      message === "Missing required parameter USERNAME" ||
      message === "Missing required parameter PASSWORD"
    ) {
      setErrMsg("");
    } else if (message === "Password attempts exceeded") {
      setErrMsg("Se superaron los intentos de contraseña");
    } else {
      setErrMsg(message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validateEmptiness();
    try {
      const client = new CognitoIdentityProviderClient({
        region: process.env.REACT_APP_COGNITO_AWS_REGION,
      });
      const input = {
        AuthFlow: "USER_PASSWORD_AUTH",
        ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        AuthParameters: {
          USERNAME: user,
          PASSWORD: pwd,
        },
      };
      const command = new InitiateAuthCommand(input);
      const response = await client.send(command);
      //const accessToken = response?.AuthenticationResult?.AccessToken;
      const refreshToken = response?.AuthenticationResult?.RefreshToken;
      //const roles= response?.data?.roles;
      //setAuth({user, roles, accessToken})
      setAuth({ user, refreshToken });
      setUser("");
      setPwd("");
      navigate("/home", {replace: true});
    } catch (err) {
      handleLoginError(err?.message);
      errRef.current.focus();
    }
  };

  return (
    <LoginWrapper>
      <>
        <h1>Iniciar Sesión</h1>
        <form onSubmit={handleSubmit}>
          <div className="login-container-input">
            <label htmlFor="username" className="input-login-lbl">
              Usuario
            </label>
            <input
              type="text"
              id="username"
              className={
                usernameError
                  ? "input-login input-validation-error"
                  : "input-login"
              }
              autoComplete="off"
              ref={userRef}
              onChange={(e) => setUser(e.target.value)}
              value={user}
            />
            <span
              className={usernameError ? "field-validation-error" : "hidden"}
            >
              El campo Usuario es requerido.
            </span>
          </div>
          <div className="login-container-input">
            <label htmlFor="password" className="input-login-lbl">
              Contraseña
            </label>
            <input
              type="password"
              id="password"
              className={
                passwordError
                  ? "input-login input-validation-error"
                  : "input-login"
              }
              onChange={(e) => setPwd(e.target.value)}
              value={pwd}
            />
            <span
              className={passwordError ? "field-validation-error" : "hidden"}
            >
              El campo Contraseña es requerido.
            </span>
          </div>
          <div className="login-container-btn">
            <span
              ref={errRef}
              className={errMsg ? "field-validation-error" : "hidden"}
              aria-live="assertive"
            >
              {errMsg}
            </span>
            <input
              type="submit"
              value="Iniciar Sesión"
              className="login-submit-btn"
            />
          </div>
        </form>
      </>
    </LoginWrapper>
  );
};

export default LoginFormTest;
